import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { LogOut, User, LayoutDashboard, Rocket, ArrowLeft } from 'lucide-react';

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <header className="glass sticky top-0 z-50 shadow-sm" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-4">
          <Link to="/" className="flex items-center text-slate-500 hover:text-green-600 transition-colors" data-testid="back-to-main-link">
            <ArrowLeft size={18} className="mr-1" />
            <span className="hidden sm:inline text-sm font-medium">{t('header.back')}</span>
          </Link>
          <Link to="/bess" className="flex items-center space-x-2" data-testid="logo-link">
            <div className="w-10 h-10 bg-gradient-to-br from-green-500 to-blue-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">BE</span>
            </div>
            <span className="text-xl font-bold text-slate-800">BESS Invest</span>
          </Link>
          </div>

          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/bess" className="text-slate-700 hover:text-green-600 font-medium transition-colors" data-testid="nav-home">
              {t('header.home')}
            </Link>
            <Link to="/bess/projects" className="text-slate-700 hover:text-green-600 font-medium transition-colors" data-testid="nav-projects">
              {t('header.projects')}
            </Link>
            <Link to="/bess/info" className="text-slate-700 hover:text-green-600 font-medium transition-colors" data-testid="nav-info">
              {t('header.info')}
            </Link>
            <Link to="/bess/impressum" className="text-slate-700 hover:text-green-600 font-medium transition-colors" data-testid="nav-impressum">
              {t('header.impressum')}
            </Link>
          </nav>

          <div className="flex items-center space-x-3">
            <LanguageSwitcher />
            {user ? (
              <>
                {user.role === 'superadmin' && (
                  <Link to="/bess/superadmin/platform" data-testid="platform-link">
                    <Button variant="outline" className="flex items-center space-x-2 border-purple-300 text-purple-700 hover:bg-purple-50">
                      <Rocket size={18} />
                      <span>{t('header.platform')}</span>
                    </Button>
                  </Link>
                )}
                <Link to="/bess/profile" data-testid="profile-link">
                  <Button variant="outline" className="flex items-center space-x-2">
                    <User size={18} />
                    <span>{t('header.profile')}</span>
                  </Button>
                </Link>
                <Link to="/bess/dashboard" data-testid="dashboard-link">
                  <Button variant="outline" className="flex items-center space-x-2">
                    <LayoutDashboard size={18} />
                    <span>{t('header.dashboard')}</span>
                  </Button>
                </Link>
                <Button onClick={handleLogout} variant="ghost" className="flex items-center space-x-2" data-testid="logout-button">
                  <LogOut size={18} />
                  <span>{t('header.logout')}</span>
                </Button>
              </>
            ) : (
              <>
                <Link to="/bess/login" data-testid="login-link">
                  <Button variant="outline">
                    {t('header.login')}
                  </Button>
                </Link>
                <Link to="/bess/register" data-testid="register-link">
                  <Button className="bg-gradient-to-r from-green-500 to-blue-600 text-white hover:from-green-600 hover:to-blue-700">
                    {t('header.register')}
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
